import { Box, Typography } from '@mui/material';

const TradingDashboard = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Trading Dashboard
      </Typography>
      {/* Add your trading dashboard content here */}
    </Box>
  );
};

export default TradingDashboard; 